import React from 'react';
import { Box, Typography, Chip, Paper, Tooltip } from '@mui/material';
import { STATUS_LABELS, APPLAB_ACCENT } from '../constants';

export default function AppCard({ app, onClick }) {
  const status = STATUS_LABELS[app.status] || STATUS_LABELS.coming_soon;
  const color = app.color || '#607D8B';

  return (
    <Paper
      onClick={onClick}
      sx={{
        p: 3,
        cursor: app.status === 'coming_soon' ? 'default' : 'pointer',
        borderRadius: 2,
        background: 'linear-gradient(135deg, #1a1a1a 0%, #252525 100%)',
        color: 'white',
        transition: 'transform 0.18s, box-shadow 0.18s, border-left 0.18s',
        borderLeft: '4px solid transparent',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        '&:hover': app.status !== 'coming_soon' ? {
          transform: 'translateY(-2px)',
          boxShadow: `0 8px 24px rgba(0,0,0,0.35)`,
          borderLeft: `4px solid ${color}`,
        } : {},
      }}
    >
      {/* Icon + status */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <Box
          sx={{
            width: 48, height: 48, borderRadius: 2,
            bgcolor: color + '22',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '1.6rem',
            border: `1px solid ${color}44`,
          }}
        >
          {app.emoji || '📦'}
        </Box>
        <Chip
          label={status.label}
          size="small"
          sx={{
            bgcolor: status.color + '22',
            color: status.color,
            border: `1px solid ${status.color}55`,
            fontWeight: 700,
            fontSize: '0.65rem',
            height: 22,
          }}
        />
      </Box>

      {/* Name */}
      <Box>
        <Typography
          variant="subtitle1"
          fontWeight={800}
          sx={{ color: 'white', lineHeight: 1.2, mb: 0.5 }}
          dangerouslySetInnerHTML={{ __html: app.displayName || app.name }}
        />
        <Typography variant="body2" sx={{ color: '#aaa', fontSize: '0.8rem', lineHeight: 1.5 }}>
          {app.tagline}
        </Typography>
      </Box>

      {/* Category + uppdrag */}
      <Box sx={{ mt: 'auto', display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
        <Chip
          label={app.category}
          size="small"
          sx={{ bgcolor: 'rgba(255,255,255,0.06)', color: '#888', fontSize: '0.65rem', height: 20 }}
        />
        {app.uppdrag && app.uppdrag.length > 0 && (
          <>
            <Tooltip
              title={app.uppdrag.map(u => `${u.projectNumber} · ${u.name}`).join('\n')}
              componentsProps={{ tooltip: { sx: { whiteSpace: 'pre-line', fontSize: '0.72rem' } } }}
            >
              <Chip
                label={app.uppdrag[0].projectNumber}
                size="small"
                sx={{ bgcolor: APPLAB_ACCENT + '18', color: APPLAB_ACCENT, fontSize: '0.62rem', height: 20 }}
              />
            </Tooltip>
            {app.uppdrag.length > 1 && (
              <Chip
                label={`+${app.uppdrag.length - 1}`}
                size="small"
                sx={{ bgcolor: 'rgba(255,255,255,0.06)', color: '#666', fontSize: '0.62rem', height: 20 }}
              />
            )}
          </>
        )}
      </Box>
    </Paper>
  );
}
